import { render, staticRenderFns } from "./PatientScheduledCall.vue?vue&type=template&id=c0b04d8a&scoped=true&"
import script from "./PatientScheduledCall.vue?vue&type=script&lang=js&"
export * from "./PatientScheduledCall.vue?vue&type=script&lang=js&"
import style0 from "./PatientScheduledCall.vue?vue&type=style&index=0&id=c0b04d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b04d8a",
  null
  
)

export default component.exports